import React, { useState } from 'react';

import { c } from 'ttag';

import { Button, OtpInput, useLoading } from '@freelancelabs/components';

const CODE_LENGTH = 6;

interface Props {
    onSubmit: (code: string) => Promise<void>;
    onCancel: () => void;
}

const TotpCodeForm = ({ onSubmit, onCancel }: Props) => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [submitting, withSubmitting] = useLoading();

    const handleSubmit = () => {
        if (submitting || code.length < CODE_LENGTH) {
            return;
        }
        setError('');
        withSubmitting(onSubmit(code)).catch(() => {
            setError(c('Mfa error').t`Invalid code.`);
            setCode('');
        });
    };

    return (
        <form
            name="totp-code-form"
            onSubmit={(event) => {
                event.preventDefault();
                handleSubmit();
            }}
            method="post"
        >
            <p className="mfa-sous">{c('Mfa help').t`Enter the 6-digit code from your authenticator app.`}</p>
            <OtpInput
                value={code}
                onValue={setCode}
                length={CODE_LENGTH}
                disabled={submitting}
                error={Boolean(error)}
                ariaLabel={c('Mfa label').t`6-digit verification code`}
            />
            <p className="mfa-statut" role="status">
                {error}
            </p>
            <div className="mfa-actions">
                <Button category="ghost" type="button" onClick={onCancel} disabled={submitting}>
                    {c('Action').t`Cancel`}
                </Button>
                <Button type="submit" loading={submitting} disabled={code.length < CODE_LENGTH}>
                    {c('Action').t`Verify`}
                </Button>
            </div>
        </form>
    );
};

export default TotpCodeForm;
